import React from "react";

// The top banner is the LCP element on the checkout. Render it as an <img> with
// fetchpriority="high" (instead of a CSS background-image) so the browser can
// discover and prioritise it as the largest contentful paint. Sizing/cover comes
// from .top-banner in base.css (aspect-ratio + object-fit), so there is no CLS.
const BannerHeader = ({ data }) => {
  if (!data) return <></>;
  if (!data?.banner) return <></>;
  return <img className="top-banner" src={data.banner} alt="" fetchpriority="high" decoding="async" />;
};

export default BannerHeader;
